import { onClickUrl, onShortUrl } from '../../core/events.js';

const QR_CONTAINER_ID = 'qr-container';

let currentUrl = null;
let qrImage = null;
let hasDrawn = false;

function drawQr(url) {
  if (!url) return;

  const container = document.getElementById(QR_CONTAINER_ID);
  if (!container) {
    console.warn('QR block: #qr-container not found; cannot draw QR code.');
    return;
  }

  if (!qrImage) {
    qrImage = document.createElement('img');
    qrImage.alt = 'Scan to open on iPhone';
    qrImage.style.display = 'block';
    qrImage.style.margin = '1rem auto';
    qrImage.style.width = '220px';
    qrImage.style.height = '220px';
    qrImage.referrerPolicy = 'no-referrer';
    container.appendChild(qrImage);
  }

  currentUrl = url;
  hasDrawn = true;

  const base = 'https://api.qrserver.com/v1/create-qr-code/';
  qrImage.src = `${base}?size=220x220&data=${encodeURIComponent(url)}`;
}

export function initQr() {
  window.renderQr = function renderQr(_containerId, url) {
    drawQr(url);
  };

  onShortUrl((event) => {
    const url = event.detail?.url;
    if (!url || url === currentUrl) return;
    drawQr(url);
  });

  onClickUrl((event) => {
    if (hasDrawn) return;
    const url = event.detail?.url;
    if (!url) return;
    drawQr(url);
  });

  const initial = window._oblikShortURL || window._oblikClickURL;
  if (initial) drawQr(initial);
}
